import { QueryUnsplashPhotosArgs } from '@trello/graphql/generated';
import {
  QueryInfo,
  prepareDataForApolloCache,
} from '../prepareDataForApolloCache';
import Unsplash from 'unsplash-js';
import memoizeOne from 'memoize-one';

const getUnsplashApi = memoizeOne(
  () =>
    new Unsplash({
      applicationId:
        '454087647775b190c574339cb2994716b17ef2f83ad11838d0ef0dac2d102e66',
      secret: '',
    }),
);

// If an empty search query is passed in, just show the latest photos from this
// collection.
const COLLECTION_ID = 317099;
const ORDER_BY = 'latest';

const DEFAULT_PAGE = 1;
const DEFAULT_PER_PAGE = 18;

export const unsplashPhotosResolver = async (
  obj: object,
  args: QueryUnsplashPhotosArgs,
  context: object,
  info: QueryInfo,
) => {
  const searchQuery = args && args.query && args.query.trim();
  const page = (args && args.page) || DEFAULT_PAGE;
  const perPage = (args && args.perPage) || DEFAULT_PER_PAGE;

  let photos;

  if (searchQuery) {
    const searchResponse = await getUnsplashApi().search.photos(
      searchQuery,
      page,
      perPage,
    );

    const searchResponseJson = await searchResponse.json();

    photos = searchResponseJson.results;
  } else {
    const photosResponse = await getUnsplashApi().collections.getCollectionPhotos(
      COLLECTION_ID,
      page,
      perPage,
      ORDER_BY,
    );

    photos = await photosResponse.json();
  }

  return prepareDataForApolloCache(photos, info);
};
